import React from 'react';

export default function ErrorPage(){
    return(
        <section>
            <h1>ErrorPage</h1>
        </section>
    )
}